import React from 'react';
import styles from './ContactUsSection.module.css';
import ImgBtnInsta from 'assets/images/instagram-img-btn.png';
import { useTranslation } from 'react-i18next';

const ContactUsSection = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.contactUsSection}>
      <div className={styles.contactUsSection__content}>
        <h2 className={styles.contactUsSection__title}>{t('contactUs.title')}</h2>
        <div className={styles.buyBtn}>
            <button className={styles.buyBtn__text} onClick={() => window.location.href = 'mailto:Vetbs7@mail.ru'} >
              {t('contactUs.text-btn')}
            </button>
        </div>
      </div>
      <div className={styles['contactUsSection__imageWrapper']}>
        <a href="https://www.instagram.com/kizomba_seym" target="_blank" rel="noopener noreferrer">
          <img className={styles['contactUsSection__socialImage']} src={ImgBtnInsta} alt="Visit us on Instagram"/>
        </a>
      </div>
    </section>
  );
};

export default ContactUsSection;